import script from "./size.vue?vue&type=script&lang=ts&setup=true"
export * from "./size.vue?vue&type=script&lang=ts&setup=true"

import "./size.vue?vue&type=style&index=0&id=3b70f268&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b70f268"]])

export default __exports__